export default __webpack_public_path__ + "static/media/stack-of-coins.2e0c5712.svg";